const mappings = {
    106: '*',
    110: '.',
    189: '-',
    190: '.',
    192: '`',
    shift: {
        51: '#',
        56: '*',
        221: '*',
    },
};

function getCharacter(keyCode, shiftKey) {
    let character = (shiftKey) ? mappings.shift[keyCode] : mappings[keyCode];
    if (!character) {
        character = String.fromCharCode(keyCode);
    }
    return character;
}

export default getCharacter;
